const onGoTop = (): void => {
  if (window.location.href.includes('dashboard')) {
    return;
  }

  window.scrollTo({
    behavior: 'smooth',
    top: 0,
  });
};

export default onGoTop;
